import { Component, OnInit } from '@angular/core';
import { QuestionarioUnoTreService } from './questionario-uno-tre.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LocalDataSource } from 'ng2-smart-table';
import { ConfirmModaleComponent } from '../confirm-modal/confirm-modale.component';
import { ModaleComponent } from '../modale/modale.component';

@Component({
  selector: 'ngx-questionario-uno-tre',
  templateUrl: './questionario-uno-tre.component.html',
  styleUrls: ['./questionario-uno-tre.component.scss'],
  providers: [QuestionarioUnoTreService, ModaleComponent, ConfirmModaleComponent]
})
export class QuestionarioUnoTreComponent implements OnInit {

  // TABLE SETTINGS
  settings: any;
  settingsMedieCds: any;
  settingsDomande: any;

  // TABLE DATA SOURCE
  source: LocalDataSource = new LocalDataSource();
  sourceMedieCds: LocalDataSource = new LocalDataSource();

  // FORM
  formRicerca: FormGroup;

  // BOOLEAN
  viewDomande: boolean = true;

  // VAR
  arrayAnni: any = [];
  listaDipa: any = [];
  listaCds: any = [];

  arrayDomande = [
  {
    idDomanda: 1,
    testoDomanda: 'Le conoscenze preliminari possedute sono risultate sufficienti per la comprensione degli argomenti previsti nel programma d’esame?'
  },
  {
    idDomanda: 2,
    testoDomanda: 'Il carico di studio dell’insegnamento è proporzionato ai crediti assegnati?'
  },
  {
    idDomanda: 3,
    testoDomanda: 'Il materiale didattico (indicato e disponibile) è adeguato per lo studio della materia?'
  },
  {
    idDomanda: 4,
    testoDomanda: 'Le modalità di esame sono state definite in modo chiaro?'
  },
  {
    idDomanda: 5,
    testoDomanda: 'Gli orari di svolgimento di lezioni, esercitazioni e altre eventuali attività didattiche sono rispettati?'
  },
  {
    idDomanda: 6,
    testoDomanda: 'Il docente stimola / motiva l’interesse verso la disciplina?'
  },
  {
    idDomanda: 7,
    testoDomanda: 'Il docente espone gli argomenti in modo chiaro?'
  },
  {
    idDomanda: 8,
    testoDomanda: 'Le attività didattiche integrative (esercitazioni, tutorati, laboratori, etc…), ove esistenti, sono utili all’apprendimento della materia? [lasciare in bianco se non pertinente]'
  },
  {
    idDomanda: 9,
    testoDomanda: 'L’insegnamento è stato svolto in maniera coerente con quanto dichiarato sul sito Web del corso di studio?'
  },
  {
    idDomanda: 10,
    testoDomanda: 'Il docente è reperibile per chiarimenti e spiegazioni?'
  },
  {
    idDomanda: 11,
    testoDomanda: 'E’ interessato/a agli argomenti trattati nell’insegnamento?'
  },
  ]


  constructor(
    private fb: FormBuilder,
    private restService: QuestionarioUnoTreService,
  ) {

    let ref = this;
    document.getElementById('nb-global-spinner').style.display = 'none';
    
    
    
    
  }
  
  ngOnInit(): void {
    let ref = this;
    ref.setupFormRicerca();
    ref.loadPage();
    
  }

  setupFormRicerca() {

    this.formRicerca = this.fb.group(
      {
        annoAccademico: [null],
        studente: ["Frequentanti"],
        dipartimento: ["*"],
        cds: ["*"],
      }
    );
  }

  toggleDomande() {
    this.viewDomande = !this.viewDomande
  }

  setupSettings() {

    let ref = this;

    this.settings = {
      noDataMessage: "Nessun dato da visualizzare",
      mode: 'external',
      hideSubHeader: true,
      actions: true,
      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
      },
      edit: {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: true,
      },
      columns: {
        attivitaDidattica: {
          title: 'ATTIVITA\' DIDATTICA',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return 'omissis';
          }
        },
        unitaDidattica: {
          title: 'UNITA\' DIDATTICA',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            let ud2 = "";
            if(row.unitaDid2.unitaDidattica){
              ud2 = `<p class="border-top-1 m-0 pt-2 w-100">${row.unitaDid2.unitaDidattica}</p>`;
            }

            return `<div class="d-flex flex-column justify-content-center align-items-center">
                      <p class="m-0 w-100 ${ud2!=''?'pb-2':''}">${cell}</p>
                      ${ud2}
                    </div>`;
					},
        },
        docentiValutati: {
          title: 'DOCENTI VALUTATI',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            let ud2 = "";
            if(row.unitaDid2.docentiValutati){
              ud2 = `<p class="border-top-1 m-0 pt-2 w-100">${row.unitaDid2.docentiValutati}</p>`;
            }

            return `<div class="d-flex flex-column justify-content-center align-items-center">
                      <p class="m-0 w-100 ${ud2!=''?'pb-2':''}">${cell}</p>
                      ${ud2}
                    </div>`;
					},
        },
        questionariCompilati: {
          title: 'QUESTIONARI COMPILATI',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            let ud2 = "";
            if(row.unitaDid2.questionariCompilati){
              ud2 = `<p class="border-top-1 m-0 pt-2 w-100">${row.unitaDid2.questionariCompilati}</p>`;
            }

            return `<div class="d-flex flex-column justify-content-center align-items-center">
                      <p class="m-0 w-100 ${ud2!=''?'pb-2':''}">${cell}</p>
                      ${ud2}
                    </div>`;
					},
        },
        is1: {
          title: 'IS1',
          type: 'html',
          valuePrepareFunction: (cell, row) => {
            let ud2 = "";
            
            if(row.unitaDid2.is1){
              if(row.unitaDid2.is1[0]=='.'){
                row.unitaDid2.is1 = `0${row.unitaDid2.is1}`;
              }
              ud2 = `<p class="border-top-1 m-0 pt-2 w-100">${row.unitaDid2.is1}</p>`;
            }

            if(cell[0]=='.'){
              cell = `0${cell}`;
            }
            return `<div class="d-flex flex-column justify-content-center align-items-center">
                      <p class="m-0 w-100 ${ud2!=''?'pb-2':''}">${cell}</p>
                      ${ud2}
                    </div>`;
					},
          
        },
        is2: {
          title: 'IS2',
          type: 'html',
          valuePrepareFunction: (cell, row) => {
            let ud2 = "";
            
            if(row.unitaDid2.is2){
              if(row.unitaDid2.is2[0]=='.'){
                row.unitaDid2.is2 = `0${row.unitaDid2.is2}`;
              }
              ud2 = `<p class="border-top-1 m-0 pt-2 w-100">${row.unitaDid2.is2}</p>`;
            }

            if(cell[0]=='.'){
              cell = `0${cell}`;
            }
            return `<div class="d-flex flex-column justify-content-center align-items-center">
                      <p class="m-0 w-100 ${ud2!=''?'pb-2':''}">${cell}</p>
                      ${ud2}
                    </div>`;
					},
        },
        is3: {
          title: 'IS3',
          type: 'html',
          valuePrepareFunction: (cell, row) => {
            let ud2 = "";
            
            if(row.unitaDid2.is3){
              if(row.unitaDid2.is3[0]=='.'){
                row.unitaDid2.is3 = `0${row.unitaDid2.is3}`;
              }
              ud2 = `<p class="border-top-1 m-0 pt-2 w-100">${row.unitaDid2.is3}</p>`;
            }

            if(cell[0]=='.'){
              cell = `0${cell}`;
            }
            return `<div class="d-flex flex-column justify-content-center align-items-center">
                      <p class="m-0 w-100 ${ud2!=''?'pb-2':''}">${cell}</p>
                      ${ud2}
                    </div>`;
					},
        },
        valutazioneMedia: {
          title: 'VALUTAZIONE MEDIA',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.valutazioneMedia, true);
          }
        },
        mediaQuesito1: {
          title: 'MEDIA QUESITO 1',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.mediaQuesito1, false);
					},
        },
        mediaQuesito2: {
          title: 'MEDIA QUESITO 2',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.mediaQuesito2, false);
					},
        },
        mediaQuesito3: {
          title: 'MEDIA QUESITO 3',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.mediaQuesito3, false);
					},
        },
        mediaQuesito4: {
          title: 'MEDIA QUESITO 4',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.mediaQuesito4, false);
					},
        },
        mediaQuesito5: {
          title: 'MEDIA QUESITO 5',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.mediaQuesito5, false);
					},
        },
        mediaQuesito6: {
          title: 'MEDIA QUESITO 6',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.mediaQuesito6, false);
					},
        },
        mediaQuesito7: {
          title: 'MEDIA QUESITO 7',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.mediaQuesito7, false);
					},
        },
        mediaQuesito8: {
          title: 'MEDIA QUESITO 8',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.mediaQuesito8, false);
					},
        },
        mediaQuesito9: {
          title: 'MEDIA QUESITO 9',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.mediaQuesito9, false);
					},
        },
        mediaQuesito10: {
          title: 'MEDIA QUESITO 10',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.mediaQuesito10, false);
					},
        },
        mediaQuesito11: {
          title: 'MEDIA QUESITO 11',
          type: "html",
          valuePrepareFunction: (cell, row) => {
            return ref.getValueMediaQuesito(cell, row.unitaDid2.mediaQuesito11, false);
					},
        },

      },
      attr: {
        class: 'styled-table-1 neutralPrimary uno_tre'
      }
    };

  }

  setupSettingsDomande() {

    let ref = this;

    this.settingsDomande = {
      noDataMessage: "Nessun dato da visualizzare",
      mode: 'external',
      hideSubHeader: true,
      hideHeader: true,
      actions: true,
      pager: {
        display: true,
        perPage: 20
      },
      columns: {
        idDomanda: {
          title: 'DOMANDA',
          type: 'string',
          width: '40px',
          attr: {
            class: 'domandeTable'
          }
        },
        testoDomanda: {
          title: 'NUM. RISPOSTE',
          type: 'string',
          valuePrepareFunction: (value, row) => {
            return value.replaceAll('Ã¨', 'è').replaceAll('Ã', 'à').replaceAll('â€™', '\'');
          }
        },
      },
      attr: {
        class: 'styled-table-1 noButtonNeutral'
      }

    };

  }

  preventLetters(ev) {

    if (!(/^([0-9.,])$/.test(ev.key))) {
      ev.preventDefault();
    }

  }

  getValueMediaQuesito(value1, valueD2, isValMedia) {
    let parseCell = parseFloat(value1);
    let bgClass = "";
    let bgClassD2 = "";
    let ud2 = "";

    if (valueD2) {
      let cellD2 = parseFloat(valueD2);
      if (cellD2 <= 2.25) {
        bgClassD2 = "bg-val-media-1";
      } else if (cellD2 >= 2.26 && cellD2 <= 2.5) {
        bgClassD2 = "bg-val-media-2";
      } else if (cellD2 > 2.5 && isValMedia==true) {
        bgClassD2 = "bg-val-media-3";
      }
      ud2 = `<p class="${bgClassD2} border-top-1 p-2 w-100 m-0">${valueD2}</p>`;
    }

    if (parseCell <= 2.25) {
      bgClass = "bg-val-media-1";
    } else if (parseCell >= 2.26 && parseCell <= 2.5) {
      bgClass = "bg-val-media-2";
    } else if (parseCell >2.5 && isValMedia==true) {
      bgClass = "bg-val-media-3";
    }

    return `<div class="d-flex flex-column justify-content-center align-items-center">
                      <p class="${bgClass} p-2 w-100 m-0">${value1}</p>
                      ${ud2}
                    </div>`;
  }

  formatNum(value) {
    let actualValue = value.toLocaleString('eu-EU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    let valueFormat = parseFloat(actualValue.replace(',', '.'));
    return valueFormat;
  }

  loadTableSettings() {

    let annoAccademico = this.formRicerca.get('annoAccademico').value || '*';
    let studente = this.formRicerca.get('studente').value || '*';
    let dipartimento = this.formRicerca.get('dipartimento').value || '*';
    let cds = this.formRicerca.get('cds').value || '*';

    this.setupSettings();


    this.restService.listAllDataQuestionario(annoAccademico, studente, dipartimento, cds).then(
      res => {
        if (res != null && res.errorCode == 0) {

          // Creiamo un oggetto per raggruppare gli elementi per "attivitaDidattica" e "unitaDidattica"
          const gruppi = {};

          res.questionari13BindList.forEach((elemento) => {
            const {
              attivitaDidattica,
              idQuesito,
              unitaDidattica,
              mediaQuesito,
              ...rest // Copia le altre proprietà
            } = elemento;
            
            if (!gruppi[attivitaDidattica]) {
              gruppi[attivitaDidattica] = {
                attivitaDidattica, // Aggiungi la chiave attivitaDidattica nell'oggetto principale
                unitaDidattica, // Aggiungi la chiave unitaDidattica nell'oggetto principale
                ...rest, // Copia le altre proprietà dall'elemento
                [`mediaQuesito${idQuesito}`]: mediaQuesito,
              };
            } else {
              // Se l'oggetto esiste già, controlla "unitaDidattica" e aggiungi all'array appropriato
              if (unitaDidattica == 2) {
                if (!gruppi[attivitaDidattica].arrayUnitaDidattiche) {
                  gruppi[attivitaDidattica].arrayUnitaDidattiche = [];
                }
                gruppi[attivitaDidattica].arrayUnitaDidattiche.push({
                  attivitaDidattica, // Aggiungi la chiave attivitaDidattica nell'oggetto interno
                  unitaDidattica, // Aggiungi la chiave unitaDidattica nell'oggetto interno
                  ...rest, // Copia le altre proprietà dall'elemento
                  [`mediaQuesito${idQuesito}`]: mediaQuesito,
                });

              } else {
                // Se "unitaDidattica" è diverso da 2, aggiorna l'oggetto corrente
                gruppi[attivitaDidattica][`mediaQuesito${idQuesito}`] = mediaQuesito;
              }
            }
          });

          // Trasformiamo l'oggetto raggruppato in un array
          let arrayConcatenato: any[] = Object.values(gruppi);
          arrayConcatenato.forEach(fg => {

            fg.unitaDid2 = {};
            if (fg.arrayUnitaDidattiche) {

              let arrayUd = fg.arrayUnitaDidattiche;

              fg.unitaDid2.docentiValutati = arrayUd[0].docentiValutati;
              fg.unitaDid2.unitaDidattica = arrayUd[0].unitaDidattica;
              fg.unitaDid2.is1 = arrayUd[0].is1;
              fg.unitaDid2.is2 = arrayUd[0].is2;
              fg.unitaDid2.is3 = arrayUd[0].is3;
              fg.unitaDid2.questionariCompilati = arrayUd[0].questionariCompilati;
              fg.unitaDid2.valutazioneMedia = arrayUd[0].valutazioneMedia;

              arrayUd.forEach((ud, y) => {
                fg.unitaDid2[`mediaQuesito${y+1}`] = ud[`mediaQuesito${y+1}`];
              });

              delete fg.arrayUnitaDidattiche;
            }
          })

          let sumMediaVal = this.getMedia(arrayConcatenato, null, true);
          let sum1 = this.getMedia(arrayConcatenato, 1, false);
          let sum2 = this.getMedia(arrayConcatenato, 2, false);
          let sum3 = this.getMedia(arrayConcatenato, 3, false);
          let sum4 = this.getMedia(arrayConcatenato, 4, false);
          let sum5 = this.getMedia(arrayConcatenato, 5, false);
          let sum6 = this.getMedia(arrayConcatenato, 6, false);
          let sum7 = this.getMedia(arrayConcatenato, 7, false);
          let sum8 = this.getMedia(arrayConcatenato, 8, false);
          let sum9 = this.getMedia(arrayConcatenato, 9, false);
          let sum10 = this.getMedia(arrayConcatenato, 10, false);
          let sum11 = this.getMedia(arrayConcatenato, 11, false);

          let arrayMedie = [
            {
              sumMediaVal,
              sum1,
              sum2,
              sum3,
              sum4,
              sum5,
              sum6,
              sum7,
              sum8,
              sum9,
              sum10,
              sum11,
            }
          ]
          this.sourceMedieCds.load(arrayMedie);
          this.source.load(arrayConcatenato);
        }
      }
    )
  }

  getMedia(arrayConcatenato, id, isMediaVal){
    let ritorno : any;

    if(isMediaVal==true){
      ritorno = arrayConcatenato.reduce((accumulator, object) => {
        let objPars = object.valutazioneMedia && object.valutazioneMedia != "" ? object.valutazioneMedia : '0';
        return accumulator + parseFloat(objPars);
      }, 0);

    } else {
      ritorno = arrayConcatenato.reduce((accumulator, object) => {
        let objPars = object[`mediaQuesito${id}`] && object[`mediaQuesito${id}`] != "" ? object[`mediaQuesito${id}`] : '0';
        return accumulator + parseFloat(objPars);
      }, 0);
    }
          
    return (ritorno / arrayConcatenato.length).toFixed(2);
  }

  loadPage() {
    this.restService.findAllAnnoAccademico().then(
      res => {
        if (res != null && res.errorCode == 0) {
          res.questionari13BindList.forEach(el => {
            this.arrayAnni.push({
              annoFormattato1: el.annoAccademico.replace('/', '.'),
              annoFormattato2: el.annoAccademico
            });

          });

          this.formRicerca = this.fb.group(
            {
              annoAccademico: [this.arrayAnni[this.arrayAnni.length - 1].annoFormattato1],
              studente: ["Frequentanti"],
              dipartimento: ["*"],
              cds: ["*"],
            }
          );

          console.log( this.formRicerca.get("annoAccademico").value);

          this.restService.findAllDipartimentiByStudentiAndAnnoAccademico(this.formRicerca.get('annoAccademico').value, this.formRicerca.get('studente').value).then(
            res2 => {
              if (res2 != null && res2.errorCode == 0) {
                this.listaDipa = res2.questionari13BindList;

              }
            }
          )

          this.restService.findCds(this.formRicerca.get('annoAccademico').value, this.formRicerca.get('studente').value, this.formRicerca.get('dipartimento').value).then(
            res3 => {
              if (res3 != null && res3.errorCode == 0) {
                this.listaCds = res3.questionari13BindList;
              }
            }
          )

          this.loadTableSettings();
          this.setupSettings();
          this.setupSettingsMedieCds();
        }
      }
    )

    this.setupSettingsDomande();
  }

  findDipa() {
    this.formRicerca.get('dipartimento').patchValue('*');
    this.formRicerca.get('cds').patchValue('*');
    this.restService.findAllDipartimentiByStudentiAndAnnoAccademico(this.formRicerca.get('annoAccademico').value, this.formRicerca.get('studente').value).then(
      res => {
        if (res != null && res.errorCode == 0) {
          this.listaDipa = res.questionari13BindList;
          this.listaCds = [];
        }
      }
    )
  }

  findCds() {
    this.formRicerca.get('cds').patchValue('*');
    this.restService.findCds(this.formRicerca.get('annoAccademico').value, this.formRicerca.get('studente').value, this.formRicerca.get('dipartimento').value).then(
      res3 => {
        if (res3 != null && res3.errorCode == 0) {
          this.listaCds = res3.questionari13BindList;
        }
      }
    )
  }

  setupSettingsMedieCds() {

    let ref = this;

    this.settingsMedieCds = {
      noDataMessage: "Nessun dato da visualizzare",
      mode: 'external',
      hideSubHeader: true,
      actions: true,
      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
      },
      edit: {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: true,
      },
      columns: {
        sumMediaVal: {
          title: 'VALUTAZIONE MEDIA',
          type: 'string',
        },
        sum1: {
          title: 'MEDIA QUESITO 1',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return cell ? cell : 'N.D.';
          }
        },
        sum2: {
          title: 'MEDIA QUESITO 2',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return cell ? cell : 'N.D.';
          }
        },
        sum3: {
          title: 'MEDIA QUESITO 3',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return cell ? cell : 'N.D.';
          }
        },
        sum4: {
          title: 'MEDIA QUESITO 4',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return cell ? cell : 'N.D.';
          }
        },
        sum5: {
          title: 'MEDIA QUESITO 5',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return cell ? cell : 'N.D.';
          }
        },
        sum6: {
          title: 'MEDIA QUESITO 6',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return cell ? cell : 'N.D.';
          }
        },
        sum7: {
          title: 'MEDIA QUESITO 7',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return cell ? cell : 'N.D.';
          }
        },
        sum8: {
          title: 'MEDIA QUESITO 8',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return cell ? cell : 'N.D.';
          }
        },
        sum9: {
          title: 'MEDIA QUESITO 9',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return cell ? cell : 'N.D.';
          }
        },
        sum10: {
          title: 'MEDIA QUESITO 10',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return cell ? cell : 'N.D.';
          }
        },
        sum11: {
          title: 'MEDIA QUESITO 11',
          type: 'string',
          valuePrepareFunction: (cell, row) => {
            return cell ? cell : 'N.D.';
          }
        },
      },
      attr: {
        class: 'styled-table-1  neutralPrimary'
      }

    };

  }

}
